import React, { useEffect, useState, useRef, useContext } from "react";
import "./Form.css";
import data from "../Home/GetStarted/body.json";
import Payment from "./Payment";
import axios from "axios";
import Modal from "react-modal";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import CheckIcon from "@mui/icons-material/Check";
import Input from "@material-ui/core/Input";
import validator from "validator";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import { ToastContainer, cssTransition } from "react-toastify";
import "animate.css/animate.min.css";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { createClient } from "contentful";
import { Link } from "react-router-dom";
import Loader from "../Loader.js";
import Profilecontext from "../../Context/Profilecontext";


Modal.setAppElement("#root");

const client = createClient({
  space: process.env.REACT_APP_SPACE_ID,
  accessToken: process.env.REACT_APP_ACCESS_TOKEN,
});

const Form = (props) => {
  const { navset, setNavset } = useContext(Profilecontext);
  const month = [
    { days: 31, name: "January" },
    { days: 28, name: "February" },
    { days: 31, name: "March" },
    { days: 30, name: "April" },
    { days: 31, name: "May" },
    { days: 30, name: "June" },
    { days: 31, name: "July" },
    { days: 31, name: "August" },
    { days: 30, name: "September" },
    { days: 31, name: "October" },
    { days: 30, name: "November" },
    { days: 31, name: "December" },
  ];
  const range = (min, max) =>
    Array.from({ length: max - min + 1 }, (_, i) => min + i);
  const [powerDay, setPowerDay] = useState(31);
  const [image, setImage] = useState();
  const [list, setList] = useState();
  const [display, setDisplay] = useState(2);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordHint, setPasswordHint] = useState(false);
  const [containsUL, setContainsUL] = useState(false); // uppercase letter
  const [containsLL, setContainsLL] = useState(false); // lowercase letter
  const [containsN, setContainsN] = useState(false); // number
  const [containsSC, setContainsSC] = useState(false); // special character
  const [contains8C, setContains8C] = useState(false); // min 8 characters
  const [disableButton, setDisableButton] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [height, setHeight] = useState();
  const [sizes, setSizes] = useState();
  const [custID, setCustID] = useState("");
  const [tokens, setTokens] = useState("");
  const [plansData, setPlansData] = useState();
  const [planID, setPlanID] = useState();
  const [loader, setloader] = useState(false);
  const [phones, setPhones] = useState(false);
  const [emails, setEmails] = useState(false);
  const [promoValid, setPromoValid] = useState(false);
  const [sucssessBoolean, setSucssessBoolean] = useState(false);
  const [fullyFreePromo, setFullyFreePromo] = useState(false);
  const [failBoolean, setFailBoolean] = useState(false);
  const [verify, setVerify] = useState();
  const [checkingPromo, setCheckingPromo] = useState(null);
  const [payloadval, setPayloadVal] = useState("");
  const [emailBorder, setEmailborder] = useState(false);
  const [firstVal, setFirstVal] = useState(false);
  const [lastVal, setLastVal] = useState(false);
  const [phoneVal, setPhoneVal] = useState(false);
  const [zipVal, setZipVal] = useState(false);
  const [passVal, setpassVal] = useState(false);
  const promoButton = useRef(null);

  const [store, setStore] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    country_code: "+1",
    birthday: "",
    password: "",
    zip_code: "",
    body_shape_color: props.color,
  });

  const [sizeCategories, setSizeCategories] = useState({
      heights: ['average', 'tall', 'petite'],
      sizes: ['regular', 'plus']
  });

  const [selectedHeight, setSelectedHeight] = useState('');
  const [selectedSize, setSelectedSize] = useState('');
  const [goForward, setGoForward] = useState(false);



  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/size_categories`)
        .then(response => {
            setSizeCategories(response.data);
        })
        .catch(error => {
            console.error('Error fetching size categories:', error);
        });
    }, []);

  const [birthdayvalue, setBirthdayvalue] = useState({
    day: "",
    month: "",
    year: "",
  });

  const validateEmail = (e) => {
    setEmailborder(false);
    var email = e.target.value.toLowerCase();
    setStore((store) => {
      return {
        ...store,
        email: email,
      };
    });
    if (validator.isEmail(email)) {
      setEmailError("");
      setEmailborder(false);
    } else {
      setEmailError("Please enter a valid email address ");
    }
  };
  const mustContainData = [
    ["an uppercase letter (A-Z)", containsUL],
    ["a lowercase letter (a-z)", containsLL],
    ["a number (0-9)", containsN],
    ["a special character (!@#$)", containsSC],
    ["at least 8 characters", contains8C],
  ];


  const validatePassword = (event) => {
    setpassVal(false);
    let passwordOne = event.target.value;
    setStore((prev) => {
      return {
        ...prev,
        password: passwordOne,
      };
    });
    setPassword(passwordOne);
    setPasswordHint(true);
    let temp_all_valid = true;
    setDisableButton(false);
    // has uppercase letter
    if (passwordOne.toLowerCase() !== passwordOne) {
      setContainsUL(true);
    } else {
      setContainsUL(false);
      temp_all_valid = false;
    }

    // has lowercase letter
    if (passwordOne.toUpperCase() !== passwordOne) {
      setContainsLL(true);
    } else {
      setContainsLL(false);
      temp_all_valid = false;
    }
    // has number
    if (/\d/.test(passwordOne)) {
      setContainsN(true);
    } else {
      setContainsN(false);
      temp_all_valid = false;
    }
    // has special character
    if (/[~`!#@$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(passwordOne)) {
      setContainsSC(true);
    } else {
      setContainsSC(false);
      temp_all_valid = false;
    }
    // has 8 characters
    if (passwordOne.length >= 8) {
      setContains8C(true);
    } else {
      setContains8C(false);
      temp_all_valid = false;
    }
    // all validations passed
    if (temp_all_valid) {
      setPasswordHint(false);
      setDisableButton(true);
    }
  };

  const [values, setValues] = React.useState({
    password: "",
    showPassword: false,
  });

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const navigate = useNavigate();
  const login = () => {
    navigate("/login");
  };

  const [id, setId] = useState();

  // API FOR GET SIZE CATEGORIES--

  const fetchsize = async (e) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/size_categories`
    );

    setHeight([...response.data.heights].reverse());

    setSizes([...response.data.sizes]);
  };

  useEffect(async () => {
    const entry = await client.getEntries({
      content_type: "shapeshoppPlans",
      order: "sys.id",
    });
    setPlansData(entry.items);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [plansData]);

  useEffect(() => {
    plansData?.filter((dat) => {
      if (dat?.fields?.planType === props.plan.plantype) {
        setList(dat);
      }
    });
    fetchsize();
    setHeight();
  }, [props.plan, plansData]);

  const [selected, setSelected] = useState();
  const handleSelected = (item) => {
    setSelected(item.id);
  };

  const [size, setSize] = useState("");
  const handleSelectedSize = (item) => {
    setSize(item.id);
  };

  useEffect(() => {
    data.filter((dat) => {
      if (dat.id === props.val) {
        setImage(dat);
      }
    });
    window.scrollTo(0, 0);
  }, [props.val]);

  const handleClick = (value, key) => {
    props.setBackground(value.background);
    setImage(value.selected_image);
    props.setColor(value.color);
    props.setVal(value.id);
    props.setStyle(value.style_number);
    setStore((prev) => {
      return {
        ...prev,
        style_number: value.style_number,
        body_shape_color: value.color,
      };
    });
    setModalIsOpen(false);
  };

  // creting promocode and changing button with condition
  const [promosuccess, setPromosuccess] = useState({
    msg: null,
    caption: null
  });

  const [promoErr, setPromoErr] = useState({
    msg: null,
    caption: null
  });

  const [promoAmt, setPromoAmt] = useState({
    promo_code: "",
  });
  const bounce = cssTransition({
    enter: "animate__animated animate__bounceIn",
    exit: "animate__animated animate__bounceOut",
  });

  // API FOR PROMO CODE---

  const getPromoCaption = (promoCode) => {
    if (promoCode.includes("50")) {
      return "50% off";
    }
    else {
      return "FREE";
    }

  }

  const isFullyFreePromo = (promoCode) => {
    if (getPromoCaption(promoCode) == "FREE") {
      return true;
    }
    else {
      return false;
    }
  }

  const getPromo = async (promommt) => {
    // e.preventDefault();
    setCheckingPromo(true);
    const res = axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/subscriptions/verify_promo_code`,
        { promo_code: promommt, plan_id: props.plan.planid }
      )
      .then((res) => {
        setVerify(res?.data?.verified);
        setFailBoolean(false);
        if (res?.data?.verified) {
          promoButton.current.click();
          setSucssessBoolean(true);
          setFailBoolean(false);
          setFullyFreePromo(isFullyFreePromo(promommt));

          setPromosuccess((success) => {
            setCheckingPromo(false);
            return {
              ...success,
              msg: "Promo code added",
              caption: getPromoCaption(promommt)
            };
          });
          setPromoErr((err) => {
            return {
              ...err,
              msg: null,
              caption: null
            };
          });
        } else {
          setFailBoolean(true);
          setCheckingPromo(null);
          setPromoErr((err) => {
            setCheckingPromo(false);
            return {
              ...err,
              msg: "Invalid code",
              caption: null
            };
          });
          setPromosuccess((success) => {
            return {
              ...success,
              msg: null,
              caption: getPromoCaption(promommt)
            };
          });
        }
      });
  };

  const setDOB = (valueyear) => {
    setStore((birthadyValue) => {
      return {
        ...birthadyValue,
        birthday: `${birthdayvalue["month"]}/${birthdayvalue["day"]}/${valueyear}`,
      };
    });
  };

  // API FOR REGISTER USER---


  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const birthDate = new Date(store.birthday).toISOString().split('T')[0];
  
    let payload = {
      first_name: store.first_name,
      last_name: store.last_name,
      phone: store.phone.slice(1),
      email: store.email,
      zip_code: store.zip_code,
      birthday: birthDate,
      password: store.password,
      height: selectedHeight || 'average',
      size: selectedSize || 'regular',
      body_shape_color: props.color
    };
  
    try {
      setloader(true);
      setGoForward(false);
  
      const config = {
        method: "post",
        url: `${process.env.REACT_APP_API_BASE_URL}/v1/users`,
        headers: {
          "Content-Type": "application/json"
        },
        data: payload
      };
  
      const response = await axios(config);
  
      if (response.status === 200) {
        // Auto-login immediately after successful registration
        const loginFormData = new URLSearchParams();
        loginFormData.append('email', store.email); // Username is the email
        loginFormData.append('password', store.password); // Use the same password from registration
  
        const loginResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/users/login`, loginFormData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
  
        if (loginResponse?.data.access_token) {
          // Store token and other data
          localStorage.setItem("tokenn", loginResponse.data.access_token);
          localStorage.setItem("color", loginResponse.data.user.body_shape_color);
          localStorage.setItem("firstTimeSignUp", true);  // First-time signup flag
  
          // Navigate to login-successful after auto-login
          navigate("/login-successful");
        } else {
          console.error("Auto-login failed after registration");
          //setLogerror(true);
        }
      }
    } catch (error) {
      console.error('Error during registration or auto-login:', error.response?.data);
  
      if (error.response?.data?.detail === "Email already registered") {
        setEmails(true);
      } else if (error.response?.data?.detail === "Phone number already registered") {
        setPhones(true);
      }
  
      setloader(false);
      setGoForward(true);
    }
  };
  
  
  const handleValues = (e) => {
    const { name, value } = e.target;
    setStore(prevStore => ({ ...prevStore, [name]: value }));
  };

  const handleNumber = (phoneNum) => {
    setStore((prev) => {
      return {
        ...prev,
        phone: phoneNum,
      };
    });
  };

  const promocheck = (e) => {
    const value = e.target.value.toUpperCase();
    const key = e.target.name;

    setPromoAmt((oldVal) => {
      return {
        ...oldVal,
        [key]: value,
      };
    });
    getPromo(value);
  };

  const remove = () => {
    setSucssessBoolean(false);
    setFailBoolean(false);
    setVerify(false);
    setPromosuccess((success) => {
      return {
        ...success,
        msg: null,
      };
    });
    setPromoErr((err) => {
      return {
        ...err,
        msg: null,
      };
    });
    setPromoAmt((element) => {
      return {
        ...element,
        promo_code: "",
      };
    });
  };

  const Monthday = (value) => {
    setPowerDay(parseInt(value));
  };

  const getMonth = (value) => {
    var select = document.getElementById("Month");
    setBirthdayvalue({
      ...birthdayvalue,
      month: moment()
        .month(select.options[select.selectedIndex].text)
        .format("M"),
      day: value,
    });
  };
  const handleChange = () => {
    // Check each required field and set validation flags
    let isValid = true;

    if (store.first_name === "") {
      setFirstVal(true);
      isValid = false;
    } else {
      setFirstVal(false);
    }

    if (store.email === "") {
      setEmailborder(true);
      isValid = false;
    } else {
      setEmailborder(false);
    }

    if (store.phone.length < 10) {
      setPhoneVal(true);
      isValid = false;
    } else {
      setPhoneVal(false);
    }

    if (store.zip_code.length < 5) {
      setZipVal(true);
      isValid = false;
    } else {
      setZipVal(false);
    }

    if (store.last_name === "") {
      setLastVal(true);
      isValid = false;
    } else {
      setLastVal(false);
    }

    if (store.password === "") {
      setpassVal(true);
      isValid = false;
    } else {
      setpassVal(false);
    }

    // Set goForward based on the overall validity of the form
    setGoForward(isValid);
};



const isSubmitDisabled = () => {
  console.log("First Name:", store.first_name);
  console.log("Last Name:", store.last_name);
  console.log("Phone:", store.phone);
  console.log("Email:", store.email);
  console.log("Password:", store.password);
  console.log("Zip Code:", store.zip_code);
  console.log("Height:", selectedHeight);
  console.log("Size:", selectedSize);
  console.log("Go Forward:", goForward);

  return (
      store.first_name === "" ||
      store.last_name === "" ||
      store.phone === "" ||
      store.phone.length < 11 ||
      store.email === "" ||
      store.password === "" ||
      store.zip_code === "" ||
      store.zip_code.length < 5 ||
      store.body_shape_color === "" ||
      selectedHeight === "" ||
      selectedSize === "" ||
      !goForward
  );
};


console.log("code", store.zip_code.length)
  return (
    <>
      <div className="container">
        <div className="body-shape-comp payment-form">
          <div className="form-heading">
            <div className="row">
                {props.display === 2 && (
                  <div className="heading-getstarted">
                    <h6 className="get">SIGN UP</h6>
                    <h4>You're on your way to style!</h4>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid form_bg">
            <div className="container form_inner">
                <div className="row">
                    <div className="form-layout">
                        {props.display === 2 && (
                            <form onSubmit={handleSubmit}>
                                {/* Form fields here */}
                                <div className="form-group form_email">
                                    <label>Email Address*</label>
                                    <input
                                        label="Email-Address"
                                        name="email"
                                        type="text"
                                        autoComplete="off"
                                        className={emailBorder ? "form-control red-alert" : "form-control"}
                                        id="userEmail"
                                        onChange={(e) => validateEmail(e)}
                                        value={store.email}
                                        required
                                    />
                                    {emails && (
                                        <div className="phone-area">Email has already been taken</div>
                                    )}
                                    {emailBorder && (
                                        <div className="email-validation">Please enter your email</div>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label>Create Password*</label>
                                    <Input
                                        name="password"
                                        type={values.showPassword ? "text" : "password"}
                                        className="form-control"
                                        id="password"
                                        onChange={(e) => validatePassword(e)}
                                        value={store.password}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                >
                                                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        required
                                    />
                                    {passVal && (
                                        <div className="first-validation">Please enter a password</div>
                                    )}
                                    {passwordHint && (
                                        <div className="password-hint-sec">
                                            {mustContainData.map((item, key) => (
                                                <div className="password-hint-wrapper" key={key}>
                                                    <div>
                                                        <div className="mr-2">
                                                            {item[1] ? <CheckIcon className="alert-green" /> : <ClearIcon className="alert-red" />}
                                                        </div>
                                                    </div>
                                                    <div style={{ paddingLeft: 5 }}>
                                                        <p className="mb-0" style={{ fontSize: 14 }}>
                                                            Must contain {item[0]}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div className="first_last_field">
                                    <div className="form-group">
                                        <label>First Name*</label>
                                        <input
                                            name="first_name"
                                            type="text"
                                            autoComplete="off"
                                            className="form-control"
                                            id="firstname"
                                            onChange={(e) => {
                                                handleValues(e);
                                                setFirstVal(false);
                                            }}
                                            value={store.first_name}
                                            required
                                        />
                                        {firstVal && (
                                            <div className="first-validation">Please enter your first name</div>
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label>Last Name*</label>
                                        <input
                                            name="last_name"
                                            type="text"
                                            autoComplete="off"
                                            className="form-control"
                                            id="lastname"
                                            onChange={(e) => {
                                                handleValues(e);
                                                setLastVal(false);
                                            }}
                                            value={store.last_name}
                                            required
                                        />
                                        {lastVal && (
                                            <div className="first-validation">Please enter your last name</div>
                                        )}
                                    </div>
                                </div>
                                <div className="first_last_field">
                                    <div className="form-group">
                                        <label>Phone*</label>
                                        <PhoneInput
                                            className="form-control"
                                            name="phone"
                                            autoComplete="off"
                                            inputProps={{
                                                required: true,
                                                autoFocus: false,
                                            }}
                                            countryCodeEditable={false}
                                            disableDropdown={true}
                                            country={"us"}
                                            onChange={(phone) => {
                                                handleValues({ target: { name: 'phone', value: phone } });
                                                setPhoneVal(phone.length < 11);
                                            }}
                                            value={store.phone}
                                            required
                                        />
                                        {phoneVal && (
                                            <div className="first-validation">Please enter your number</div>
                                        )}
                                        {phones && (
                                            <div className="phone-area">This number is already taken</div>
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label>Zip Code*</label>
                                        <input
                                            name="zip_code"
                                            autoComplete="off"
                                            className="form-control"
                                            id="number"
                                            onChange={(e) => {
                                                handleValues(e);
                                                setZipVal(e.target.value.length < 5);
                                            }}
                                            value={store.zip_code}
                                            required
                                            maxLength="5"
                                            minLength="5"
                                        />
                                        {zipVal && (
                                            <div className="first-validation">Please enter your zip code</div>
                                        )}
                                    </div>
                                </div>
                                <div className="first_last_field">
                                    <div className="form-group birthday_field">
                                        <label>Birthday</label>
                                        <input
                                            name="birthday"
                                            type="date"
                                            autoComplete="off"
                                            className="form-control"
                                            onChange={handleValues}
                                            value={store.birthday}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="height-toggle">
                                    <label htmlFor="exampleFormControlSelect1">Height</label>
                                    <div className="form-group size">
                                        <select
                                            value={selectedHeight}
                                            onChange={(e) => setSelectedHeight(e.target.value)}
                                            className="form-control"
                                            required
                                        >
                                            <option value="" disabled>Select height</option>
                                            {sizeCategories.heights.map(height => (
                                                <option key={height} value={height}>{height}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="size-toggle">
                                    <label htmlFor="exampleFormControlSelect2">Size</label>
                                    <div className="form-group size">
                                        <select
                                            value={selectedSize}
                                            onChange={(e) => setSelectedSize(e.target.value)}
                                            className="form-control"
                                            required
                                        >
                                            <option value="" disabled>Select size</option>
                                            {sizeCategories.sizes.map(size => (
                                                <option key={size} value={size}>{size}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="terms form">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value=""
                                        id="flexCheckDefault"
                                        onChange={handleChange}
                                    />
                                    <p>
                                        &nbsp; I have read and agree to the &nbsp;
                                        <Link to="/privacy-policy" target="blank">
                                            <u>Privacy Policy</u>
                                        </Link>{" "}
                                        and &nbsp;
                                        <Link to="/term" target="blank">
                                            <u>Terms of Service</u>
                                        </Link>{" "}
                                    </p>
                                </div>
                                {props.display === 2 && (
                                    <div className="action-btn">
                                        <button
                                              id="continue to payment"
                                              type="submit"
                                              className="btn-lg-secondary-outline"
                                              disabled={isSubmitDisabled()}
                                          >
                                              {sucssessBoolean === true ? "Submit" : "Continue"}
                                          </button>
                                    </div>
                                )}
                            </form>
                        )}
                        {props.display === -1 && (
                            <Payment
                                display={props.display}
                                userID={id}
                                plan={props.plan}
                                color={props.color}
                                stylenumber={props.style}
                                background={props.background}
                                custID={custID}
                                setCustID={setCustID}
                                tokens={tokens}
                                planID={planID}
                                list={list}
                                store={store}
                                setStore={setStore}
                                selected={selected}
                                setSelected={setSelected}
                                size={size}
                                setSize={setSize}
                                payloadval={payloadval}
                                setPayloadVal={setPayloadVal}
                                promoCode={promoAmt?.promo_code}
                            />
                        )}
                        <div className="action-btn"></div>
                        <div className="body_shape already-account">
                            <h6>
                                Already have an account? <u onClick={login}> Sign in </u>
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      <Loader loader={loader} />

      <ToastContainer
        transition={bounce}
        position="bottom-right"
        autoClose={0.5}
        hideProgressBar={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
      />
    </>
  );
};

export default Form;
